import { ApplicationHouseholdExpensesScreen } from "@/interactors/ApplicationHouseholdExpensesScreen";

export default function HouseholdExpenses() {
  return <ApplicationHouseholdExpensesScreen />;
}
